import { render, staticRenderFns } from "./delete-component-modal.vue?vue&type=template&id=65b5c668"
import script from "./delete-component-modal.vue?vue&type=script&lang=ts"
export * from "./delete-component-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports